import { extendTheme } from '@chakra-ui/react';

import { Button } from './components/button';
import { Form } from './components/form';
import { Input } from './components/input';
import { Link } from './components/link';
import { Select } from './components/select';
import { SelectControl } from './components/select-control';
import { Skeleton } from './components/skeleton';
import { TextInputControl } from './components/text-input-control';
import { config } from './config';
import {
    colors, fonts, breakpoints
} from './foundations';
import styles from './styles';

/**
 * Base theme for mathletics, based on Designs from UX team in Figma.
 *
 * @see Figma https://www.figma.com/file/AVVZO09XE8fZ0uuOaJYcQg/B2C-Onboarding---for-Dev
 */
export const theme = extendTheme({
    fonts,
    colors,
    config,
    styles,
    breakpoints,
    components: {
        Button,
        Form,
        Input,
        Select,
        Link,
        TextInputControl,
        SelectControl,
        Skeleton
    }
});
